import {
    postImportCostProviderLoading,
    postImportCostProviderRequest,
    postImportCostProviderSuccess,
    postImportCostProviderReject,
    postImportCostProviderReset
} from "../../actions/importCostProvider/post";

export const postImportCostProvider = (formData) => async (dispatch, getState) => {
    dispatch(postImportCostProviderLoading());
    try {
        const { data } = await postImportCostProviderRequest(formData, getState);
        dispatch(postImportCostProviderSuccess(data))
    } catch (error) {
        dispatch(postImportCostProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(postImportCostProviderReset()) }, 3000);
    }
    return Promise.resolve();
};
